export default {
	computed: {
		appModel() {
			return this.$store.state.app || storeInstance.state.app;
		},
		authModel() {
			return this.$store.state.app.auth || storeInstance.state.app.auth;
		},
		gameModel() {
			return this.$store.state.app.game || storeInstance.state.app.game;
		},
		
		store() {
			return this.$store || storeInstance;
		},
		state() {
			return this.$store.state || storeInstance.state;
		},
		routeName() {
			return this.$route.name;
		},
	},
	methods: {
		setPageTitle(title) {
			this.appModel.setPageTitle(title);
		},
	},
};
